import { render, staticRenderFns } from "./BSBaseDatetimePicker.vue?vue&type=template&id=647e8c38&scoped=true"
import script from "./BSBaseDatetimePicker.vue?vue&type=script&lang=js"
export * from "./BSBaseDatetimePicker.vue?vue&type=script&lang=js"
import style0 from "./BSBaseDatetimePicker.vue?vue&type=style&index=0&id=647e8c38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e8c38",
  null
  
)

export default component.exports